'use client'

import { useState, Suspense } from 'react'
import Link from 'next/link'
import cn from 'classnames'

import CloseIcon from './close-icon.svg'
import QuakeLogo from './quake-logo.svg'

import NavItemList from './NavItemList'
import LocaleSwitcher from './LocaleSwitcher'

import styles from './index.module.scss'

import type { NavItem } from './types'

type NavbarMinimalClientProps = {
  navItems: NavItem[]
}

export default function NavbarMinimalClient({ navItems }: NavbarMinimalClientProps) {
  const [expanded, setExpanded] = useState(false)

  return (
    <div className={styles.header}>
      <div className={cn('container mx-auto', styles.container)}>
        <button
          type="button"
          className={styles.toggle}
          aria-label="Open navigation"
          aria-expanded={expanded}
          onClick={() => setExpanded(true)}
        >
          <span />
          <span />
          <span />
        </button>

        <div
          className={cn(styles.overlay, expanded && styles.expanded)}
          aria-hidden="true"
          onClick={() => setExpanded(false)}
        />

        <nav className={cn(styles.nav, expanded && styles.expanded)} aria-label="Main navigation">
          <button
            type="button"
            className={styles.closeButton}
            aria-label="Close navigation"
            onClick={() => setExpanded(false)}
          >
            <CloseIcon className={styles.close} />
          </button>

          <ul>
            {navItems.map((item, index) => {
              return (
                <li className={styles.category} key={index}>
                  <div className={styles.title}>{item.label}</div>

                  {item.children && (
                    <NavItemList items={item.children} onNavigate={() => setExpanded(false)} />
                  )}
                </li>
              )
            })}
          </ul>
        </nav>

        <Link href="https://lisbonquake.com" className={styles.brand} aria-label="Go to home page">
          <QuakeLogo className="w-[150px]" />
        </Link>

        <LocaleSwitcher />
      </div>
    </div>
  )
}
